module.exports = __webpack_public_path__ + "img/s9.5c542d2b.png";